module.exports = __webpack_public_path__ + "media/images/application/default/default-politique-5237e9baf27b485ad7a2dc016606f3ac.jpg";